































import { Component, Prop, Vue } from "vue-property-decorator";
import { getSolution } from "@/services/render/renderService";
import { RenderTemplateModel, RenderContentModel } from "@/services/render/types";
import SolutionRender from "@/components/render/SolutionRender.vue";
import { Getter } from "vuex-class";
import PreviewFullScreenHeader from "@/components/common/preview/PreviewFullScreenHeader.vue";
import PreviewSidebar from "@/components/common/preview/PreviewSidebar.vue";
const namespace: string = "authentication";

@Component({
    components: {
        SolutionRender,
        PreviewFullScreenHeader,
        PreviewSidebar
    }
})
export default class SolutionPreview extends Vue {
    @Prop() private solutionId!: string;
    @Getter("getToken", { namespace }) getToken!: string;

    // local state
    width = 0;
    height = 0;
    title = "";
    timezoneId = "";
    dateTime = "";
    scale = 1;
    fitScale = 0;
    bgColor = "#ffffff";

    // lifecycle hooks
    created() {
        this.solutionId = this.solutionId
            ? this.solutionId
            : this.$route.params.boarId;
        getSolution(this.solutionId).then(response => {
            this.width = response.width;
            this.height = response.height;
            this.title = response.name;
            this.setScale();
            this.timezoneId = response.timeZoneId;
        });
    }

    renderSolution(value: string) {
        this.dateTime = value;
    }

    setScale() {
        var scaleX = (window.innerWidth / 100 * 95) / this.width;
        var scaleY = (window.innerHeight / 100 * 88) / this.height;
        this.scale = scaleX <= scaleY ? scaleX : scaleY;
        this.scale = this.scale >= 1 ? 1 : this.scale;
        this.scale = Math.floor(this.scale * 100) / 100;
        this.fitScale = this.scale;
    }

    onScale(value: number) {
        this.scale = value;
    }

    changeBg(color: string) {
        this.bgColor = color;
    }

    // computed

    get adaptedSize() {
        return {
            transform: "scale(" + this.scale + ")",
            "transform-origin": "left top",
            height: `${this.height}px`,
            width: `${this.width}px`
        };
    }
}
